import PartPurchaseQualityControlConfirmation from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmation';

export default class PartPurchaseQualityControlConfirmationFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partPurchaseQualityControlId  = '';
		this.partPurchaseQualityControlPartPurchaseQualityControlDate = '';
		this.partPurchaseQualityControlConfirmationNumber = '';
		this.partPurchaseQualityControlConfirmationDateFrom = '';
		this.partPurchaseQualityControlConfirmationDateTo = '';
		this.revisi = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partPurchaseQualityControlId : '0',
			partPurchaseQualityControlPartPurchaseQualityControlDate : '0',
			partPurchaseQualityControlConfirmationNumber : '0',
			partPurchaseQualityControlConfirmationDateFrom : '0',
			partPurchaseQualityControlConfirmationDateTo : '0',
			revisi : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}